import {
  BaseInsuranceCoverage,
  CoverageId,
  CoverageType,
  defaultStageValidate,
  FieldMap,
  getHasPrimaryCoverage,
  getHasSecondaryCoverage,
  getInsuranceCoverageField,
  getPregnancyCoverageType,
  ValidationErrors,
} from '@hb/shared'
import { useMemo } from 'react'
import { useInsuranceInfoStage } from './InsuranceInfoStageContext'

export interface CoverageStatus {
  data: Partial<BaseInsuranceCoverage>
  hasCoverage: boolean
  field: FieldMap
  type: CoverageType | null
  errors: ValidationErrors
  complete: boolean
}

export const useCoverageStatus = (label: CoverageId) => {
  const { insuranceInfoData: values } = useInsuranceInfoStage()
  const hasCoverage = useMemo(
    () =>
      label === 'primary'
        ? getHasPrimaryCoverage(values ?? {})
        : getHasSecondaryCoverage(values ?? {}),
    [values, label],
  )

  const coverageType = useMemo(() => getPregnancyCoverageType(label, values ?? {}), [values, label])

  const coverageField = useMemo(
    () => getInsuranceCoverageField(coverageType === 'medicaid', false, true),
    [coverageType],
  )

  const errors = useMemo(
    () => defaultStageValidate(coverageField)(values?.[`${label}Coverage`] ?? {}),
    [values, coverageField, label],
  )

  const complete = useMemo(() => hasCoverage && !errors, [hasCoverage, errors])
  // const [primaryCoverageComplete, setPrimaryCoverageComplete] = useState(
  //   hasPrimaryCoverage && !primaryCoverageErrors,
  // )

  return {
    data: values?.[`${label}Coverage`] ?? {},
    hasCoverage,
    field: coverageField,
    type: coverageType,
    errors,
    complete,
  }
}
